import type { Layout, LayoutElement } from "@entaconsulting/form";
import { isContainerElement, isFieldElement } from "@entaconsulting/form";
import normalizePath from "./normalizePath";

const getRenamedLayoutElements = (
  elements: LayoutElement[] | undefined = [],
  normalizedOldName: string,
  normalizedNewName: string
): LayoutElement[] => {
  return elements.map((element) => {
    if (isContainerElement(element)) {
      return {
        ...element,
        elements: getRenamedLayoutElements(
          element.elements,
          normalizedOldName,
          normalizedNewName
        ),
      };
    } else if (isFieldElement(element)) {
      const currentName = element.name;
      const normalizedCurrentName = normalizePath(currentName);

      return {
        ...element,
        name:
          normalizedCurrentName === normalizedOldName
            ? normalizedNewName
            : currentName,
      };
    } else return element;
  });
};

const generateRenamedLayoutObject = (
  layoutObject: Layout,
  normalizedOldName: string,
  normalizedNewName: string
): Layout => {
  const newLayoutObject: Layout = {
    ...layoutObject,
    header: {
      ...layoutObject.header,
      elements: getRenamedLayoutElements(
        layoutObject.header?.elements,
        normalizedOldName,
        normalizedNewName
      ),
    },
    elements: getRenamedLayoutElements(
      layoutObject.elements,
      normalizedOldName,
      normalizedNewName
    ),
  };

  return newLayoutObject;
};

export default generateRenamedLayoutObject;
